import {useMutation, UseMutationOptions, useQueryClient,} from '@tanstack/react-query';
import {GenerationResultDto} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export interface ValidateCampaignAudienceParams {
  id: string;
  organizationId: string;
  excludeConflicts?: boolean;
}

export const validateCampaignAudience = async (params: ValidateCampaignAudienceParams): Promise<GenerationResultDto> => {
  return await tinctApi.campaigns.validateCampaignAudience(params.id, params.excludeConflicts);
};

export const useValidateCampaignAudience = (
  options?: Omit<
    UseMutationOptions<GenerationResultDto, ApiError, ValidateCampaignAudienceParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: validateCampaignAudience,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      queryClient.invalidateQueries({ queryKey: ['organization', args[1].organizationId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
